import React from 'react';
import { Card, CardContent } from './ui/Card';
import { MapPin, Clock, Building, MessageCircle } from 'lucide-react';
export function TrustSection() {
  const features = [{
    icon: <MapPin className="w-8 h-8" data-id="element-300" />,
    title: 'Locally Owned',
    description: 'Based in Far East El Paso. We know the community because we are part of it.'
  }, {
    icon: <Clock className="w-8 h-8" data-id="element-301" />,
    title: 'Reliable Every Time',
    description: 'We show up when we say we will. No surprises, no excuses.'
  }, {
    icon: <Building className="w-8 h-8" data-id="element-302" />,
    title: 'Residential & Commercial',
    description: 'From family homes to offices, we clean it all right the first time.'
  }, {
    icon: <MessageCircle className="w-8 h-8" data-id="element-303" />,
    title: 'Bilingual Service',
    description: 'English and Spanish, clear communication every time.'
  }];
  return <section className="py-20 md:py-28 bg-[#FBFCFB]" data-id="element-304">
      <div className="container mx-auto px-4" data-id="element-305">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-306">
          <span className="text-brand-green font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-307">
            Why Choose Us
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy" data-id="element-308">
            The Comfy Clean Difference
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-309">
          {features.map((feature, index) => <Card key={index} className="border-0 shadow-sm hover:shadow-md transition-shadow bg-white rounded-2xl" data-id="element-310">
              <CardContent className="p-8 text-center md:text-left flex flex-col items-center md:items-start" data-id="element-311">
                <div className="w-16 h-16 rounded-2xl bg-brand-green/10 flex items-center justify-center mb-6 text-brand-green" data-id="element-312">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-heading font-bold text-gray-900 mb-3" data-id="element-313">
                  {feature.title}
                </h3>
                <p className="text-gray-600 font-body leading-relaxed" data-id="element-314">
                  {feature.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}